// tslint:disable
/**
 * TC API
 * TestCollab is a test management tool that helps development teams carry out testing effectively and avoid failures. # Introduction This is an API documentation for TestCollab 2.   # Authentication TestCollab supports two forms of authentication:   - An <b>API token</b> is required to make API calls. The token can be generated from user's profile; to obtain it login to your TestCollab account and go to ['My Profile Settings'](https://testcollab.io/my_profile) and switch to API Token tab. Click on \"Generate new API token\", Once the token is generated it can be sent as a query parameter for the API calls made - https://api.testcollab.io/projects?token=<generated-API-token>    - <b>Bearer authentication</b> (also called token authentication) is an HTTP authentication scheme that involves security tokens called bearer tokens. You can generate bearer auth token using [Login](#operation/login) API.     Send this token as the Authorization header while making requests to protected resources:     `Authorization: Bearer <token>`    For making API calls, we recommend using the <b>API token</b> generated from user profile page as it won't affect the on-going user session and will be available until it is revoked by the user who generated it.      # Error Handling Error responses   - `Not Found` - Error is sent when requested resource is not available.   - `Unauthorized - invalid token` - Error is sent when API token sent with the request is invalid or revoked. Error contains status code 401        - `Forbidden` - Error is sent when logged in user is not part of the company, project or his role does not allow to complete given action. Response consist of 403 status code and more information is given in error message. 
 *
 * OpenAPI spec version: 2.3.1
 * Contact: support@testcollab.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists } from '../runtime';
import {
    CustomFieldInputPayload,
    CustomFieldInputPayloadFromJSON,
    CustomFieldInputPayloadToJSON,
} from './';

/**
 * 
 * @export
 * @interface RequirementPayload
 */
export interface RequirementPayload {
    /**
     * 
     * @type {number}
     * @memberof RequirementPayload
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof RequirementPayload
     */
    requirementManager?: string;
    /**
     * 
     * @type {string}
     * @memberof RequirementPayload
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof RequirementPayload
     */
    externalId: string;
    /**
     * 
     * @type {number}
     * @memberof RequirementPayload
     */
    project: number;
    /**
     * Stringified JSON object
     * @type {string}
     * @memberof RequirementPayload
     */
    requirementData?: string;
    /**
     * Requirement description - applicable only for inbuilt requirementManager
     * @type {string}
     * @memberof RequirementPayload
     */
    description?: string;
    /**
     * Requirement folder id - applicable only for inbuilt requirementManager
     * @type {number}
     * @memberof RequirementPayload
     */
    requirementFolder?: number;
    /**
     * Array of custom fields - applicable only for inbuilt requirementManager
     * @type {Array<CustomFieldInputPayload>}
     * @memberof RequirementPayload
     */
    customFields?: Array<CustomFieldInputPayload>;
    /**
     * Array of file ids - applicable only for inbuilt requirementManager
     * @type {Array<string>}
     * @memberof RequirementPayload
     */
    attachments?: Array<string>;
    /**
     * Array of testcase ids - applicable only for inbuilt requirementManager
     * @type {Array<number>}
     * @memberof RequirementPayload
     */
    testcases?: Array<number>;
}

export function RequirementPayloadFromJSON(json: any): RequirementPayload {
    return {
        'id': !exists(json, 'id') ? undefined : json['id'],
        'requirementManager': !exists(json, 'requirementManager') ? undefined : json['requirementManager'],
        'title': !exists(json, 'title') ? undefined : json['title'],
        'externalId': json['external_id'],
        'project': json['project'],
        'requirementData': !exists(json, 'requirement_data') ? undefined : json['requirement_data'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'requirementFolder': !exists(json, 'requirement_folder') ? undefined : json['requirement_folder'],
        'customFields': !exists(json, 'custom_fields') ? undefined : (json['custom_fields'] as Array<any>).map(CustomFieldInputPayloadFromJSON),
        'attachments': !exists(json, 'attachments') ? undefined : json['attachments'],
        'testcases': !exists(json, 'testcases') ? undefined : json['testcases'],
    };
}

export function RequirementPayloadToJSON(value?: RequirementPayload): any {
    if (value === undefined) {
        return undefined;
    }
    return {
        'id': value.id,
        'requirementManager': value.requirementManager,
        'title': value.title,
        'external_id': value.externalId,
        'project': value.project,
        'requirement_data': value.requirementData,
        'description': value.description,
        'requirement_folder': value.requirementFolder,
        'custom_fields': value.customFields === undefined ? undefined : (value.customFields as Array<any>).map(CustomFieldInputPayloadToJSON),
        'attachments': value.attachments,
        'testcases': value.testcases,
    };
}


